
export const MOSTRADOR = ['RECOJO EN ALMACEN', 'ENTREGO EN MANO', 'DIRECCIÓN: C/SUBIDA AL MAYORAZGO 4B DE LUNES A VIERNES 8 A 15 H\n', 'RECOGE EN MOSTRADOR MI CLIENTE FINAL'];
export const CONFIG_MARQUESINA = 'marquesina';
export const CONFIG_MARQUESINA_DESP = 'marquesina_desp';
export const LOCALE = 'es-ES';
export const ID_CLIENTE_FINAL = '43000001';
export const FORMAT_LOCALE_DIGIT = '2-digit';
export const ORDER_TYPE = {
    ALBARAN: 'albaran',
    PEDIDO: 'pedido'
};
export const ORDER_ACTION = {
    COMPRAS: "compras",
    VENTAS: "ventas"
}
// Estados de Nave 1 (final_ventas). Flujo: SIN_PREPARAR → EN_PREPARACION → PREPARADO →
// EN_REVISION → FINALIZADO, es decir '1' → '2' → '5' → '4' → '3'. Los códigos no siguen el
// flujo: '3' era el estado final antes de existir FINALIZADO y la API lo conserva como tal
// (api/docs/api/ventas.md, "Estados de Pedido")
export const ORDER_STATE = {
    SIN_PREPARAR: '1',
    EN_PREPARACION: '2',
    PREPARADO: '5',
    EN_REVISION: '4',
    FINALIZADO: '3'
}
// Estados de Nave 2 (registro_pedido_n2): termina en PREPARADO, que aquí es '3'.
// La API rechaza '4' y '5' en POST ventas/n2/asignar
export const ORDER_STATE_N2 = {
    SIN_PREPARAR: '1',
    EN_PREPARACION: '2',
    PREPARADO: '3'
}
export const ESTADO_PROCESO = {
    SIN_PREPARADOR: 'Sin preparador',
    SIN_REVISOR: 'Sin revisor'
}
export const ORDER_STATE_COMPRAS = {
    SIN_INICIAR: 'Sin iniciar',
    RECEPCIONADO: 'Recepcionado',
    EN_PROCESO: 'En proceso',
    COMPLETO: 'Completo',
}
export const IMAGE_TYPE = {
    TIF: { MIME: 'image/tiff', EXT: 'tif'},
    PDF: { MIME: 'application/pdf', EXT: 'pdf'}
}
export const INCIDENCIA_ESTADO = {
    ABIERTAS: 'abiertas'
}
export const INCIDENCIA_ESTADO_VALOR = {
    ABIERTA: 1,
    EN_PROCESO: 2,
    CERRADA: 3
}
export const INCIDENCIA_TIPO = {
    ART: 'art',
    PED: 'ped',
    ALB: 'alb'
}
export const INCIDENCIA_ORIGEN = {
    SALES: 'sales',
    PURCHASES: 'purchases',
    STICKER: 'sticker',
    IVENTARIO: 'inventario',
    NAVE2: 'nave2'
}
export const RUTAS = {
    IMAGENES: 'imagenes'
}
export const LOCALSTORAGEKEYS = {
    EJERCICIO: 'ejercicio'
}
export const MOSTRADORES = [
    { value: 'mostrador-1', label: 'Mostrador 1' },
    { value: 'mostrador-2', label: 'Mostrador 2' },
    { value: 'servicio-tecnico', label: 'Servicio técnico' },
];
export const getMostradorLabel = (value) => {
    const found = MOSTRADORES.find((m) => m.value === value);
    return found ? found.label : value;
};
export const TRASPASO_ESTADO = {
    PENDIENTE: 'PENDIENTE',
    TRASPASADO: 'TRASPASADO',
};

// Agenda
export const PRIORITY_BADGE = { bajo: 'success', medio: 'warning', alto: 'danger' }
export const PRIORITY_OPTIONS = [
    { value: 'bajo', label: 'Bajo' },
    { value: 'medio', label: 'Medio' },
    { value: 'alto', label: 'Alto' },
]
export const ACTIONS = {
    ADD_TASK: 'ADD_TASK',
    UPDATE_TASK: 'UPDATE_TASK',
    DELETE_TASK: 'DELETE_TASK',
    MOVE_TASK: 'MOVE_TASK',
    SET_TASK_ORDER: 'SET_TASK_ORDER',
    ADD_COLUMN: 'ADD_COLUMN',
    RENAME_COLUMN: 'RENAME_COLUMN',
    DELETE_COLUMN: 'DELETE_COLUMN',
    SET_COLUMN_ORDER: 'SET_COLUMN_ORDER',
    INIT_FROM_API: 'INIT_FROM_API',
}